<script lang="ts" setup>
import { computed } from 'vue'
import { useRunValidation } from '@/queries/saved-calls'
import ValidationDiffTable from './ValidationDiffTable.vue'

// One regression-batch item's per-service diff. Owns its own fetch so the parent can render it inside
// a v-for (hooks can't live in a loop). Only fetches when the item actually has a recorded validation.
const props = defineProps<{
  savedCallId: string
  workflowRunId: string
  // Null when the run wasn't validated (no baseline set when it ran) — we skip the fetch entirely.
  validationResultId: string | null
}>()

const callId = computed(() => (props.validationResultId ? props.savedCallId : null))
const runId = computed(() => (props.validationResultId ? props.workflowRunId : null))
const { validation, validationLoading } = useRunValidation(callId, runId)
</script>

<template>
  <div v-if="validationResultId" class="mt-2">
    <div v-if="validationLoading" class="text-muted small">
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>Loading comparison…
    </div>
    <ValidationDiffTable
      v-else-if="validation"
      mode="diff"
      :diffs="validation.serviceDiffs"
    />
  </div>
</template>
